/** ดาบชักเร็วโคมเหล็ก (lane C3 skeleton): lantern fire + gold, rising embers. Built from swordKit via families/swordArtGen.ts; polish later. */
import { makeArt } from '../families/swordArtGen';

export const SPRING_FX: ReturnType<typeof makeArt> = makeArt('quick-draw-sabre', { a: 'fire', b: 'gold', motif: 'ember' }, [
  ['sp-flash', 'lock'],
  ['sp-pierce', 'break'],
  ['sp-petals', 'slash'],
  ['sp-bloom', 'sweep', 5],
  ['sp-hunt', 'qi'],
  ['sp-verdict', 'slash'],
  ['sp-loyal', 'buff'],
  ['sp-decree', 'power', 5],
]);
